export const environment = {
  production: false,
  env: 'qa',
  baseUrl : 'https://qatools.yellowfolder.com/',
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages',
  },

  oktaConfig : {
    clientId: "0oa18aiwob0s1tzlM0h8",
    issuer: "https://qalogin.yellowfolder.com/oauth2/aus15dy0bmuinMlgP0h8",
    redirectUri: 'https://qatools.yellowfolder.com/callback',
    scopes: ['openid', 'profile', 'email'],
    testing: {
      disableHttpsCheck: true
    }
  },
  
  // web urls
  domain : "https://qaerm.yellowfolder.com",
  domain_login : "https://qalogin.yellowfolder.com",
  url : "https://qaerm.yellowfolder.com/toolsapi"
};